
import React, { useEffect, useState } from 'react';
import { createPortal } from 'react-dom';
import { motion, AnimatePresence } from 'framer-motion';

interface XpGainToastProps {
    xp: number;
    message: string;
    isVisible: boolean;
    onClose: () => void;
}

export const XpGainToast: React.FC<XpGainToastProps> = ({ xp, message, isVisible, onClose }) => {
    const [mounted, setMounted] = useState(false);

    useEffect(() => {
        setMounted(true);
    }, []);

    useEffect(() => {
        if (isVisible) {
            const timer = setTimeout(() => {
                onClose();
            }, 3000);
            return () => clearTimeout(timer);
        }
    }, [isVisible, onClose, xp]);

    if (!mounted || !isVisible) {
        return null;
    }

    const toastContent = (
        <AnimatePresence mode="wait">
            <motion.div
                key="xp-toast"
                initial={{ opacity: 0, y: 10 }}
                animate={{ opacity: 1, y: 0 }}
                exit={{ opacity: 0, y: 5 }}
                transition={{ duration: 0.2 }}
                className="fixed bottom-24 left-1/2 -translate-x-1/2 z-50 px-6 py-3 bg-neutral-900/95 backdrop-blur-sm border border-orange-500/20 rounded-lg pointer-events-auto"
            >
                <span className="text-lg font-semibold text-orange-400">
                    +{xp} XP
                </span>
            </motion.div>
        </AnimatePresence>
    );

    return createPortal(toastContent, document.body);
};
